<template>
  <div class="joinTeam">
    <div v-loading="loading" v-if="enable">
      <img class="logo" src="~@/assets/images/logoa.png" />
      <div class="inviteCon">
        <img src="~@/assets/images/logo-bg.png" />
        <p>
          HI，<span>{{ inviterName }}</span> 邀请你加入【{{ teamName }}】
        </p>
        <el-button type="primary" @click="submit">马上加入</el-button>
      </div>
    </div>
    <div class="enable" v-else>
      <img src="~@/assets/images/expired.png" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getToken } from '@/utils/auth'
import {
  inviterMsg,
  inviteMemberApi,
  // switchTeam,
  detectTeam
} from '@/api/teamManagement'

export default {
  name: 'joinTeam',
  data () {
    return {
      loading: false,
      inviterName: '',
      teamName: '',
      teamId: '',
      enable: true
    }
  },
  computed: {
    ...mapGetters(['userInfomation'])
  },
  async created () {
    await this.getInviterMsg()

    if (this.enable) {
      if (getToken()) {
        const { data } = await detectTeam({
          teamId: this.teamId,
          userId: this.userInfomation.id
        })
        if (data) {
          this.$message.success('你已加入该团队!')
          // this.loading = true
          // localStorage.setItem('teamId', this.teamId)
          // await switchTeam({ teamId: this.teamId })
          // await this.GetInfo()
          this.$router.push('/controlPlatform')
          // this.loading = false
        }
      }
    }
  },
  mounted () {},
  methods: {
    ...mapActions(['GetInfo']),
    async getInviterMsg () {
      const res = await inviterMsg({ noncestr: this.$route.params.id })
      this.inviterName = res.data.inviterName
      this.teamName = res.data.teamName
      this.teamId = res.data.teamId
      this.enable = res.data.enable
    },
    async join () {
      await inviteMemberApi({ noncestr: this.$route.params.id })
      this.$message.success('加入团队成功!')
      // localStorage.setItem('teamId', this.teamId)
      // await switchTeam({ teamId: this.teamId })
      // await this.GetInfo()
      this.$router.push({ path: '/controlPlatform' })
    },
    submit () {
      if (getToken()) {
        this.join()
      } else {
        this.$router.push({
          path: '/login',
          query: { teamId: this.teamId, noncestr: this.$route.params.id }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.joinTeam {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(0deg, #252527, #3d3d40);
  position: relative;
  font-family: Source Han Sans SC;
  > div {
    width: 100%;
    height: 100%;
  }
  .enable {
    position: relative;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .logo {
    position: absolute;
    left: 63px;
    top: 59px;
  }
  .inviteCon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    p {
      font-size: 24px;
      margin: 28px 0 30px 0;
    }
    .el-button {
      width: 200px;
      height: 40px;
      border-radius: 20px;
    }
  }
}
</style>
